import { useCallback, useRef, useState } from 'react';

export const usePromiseModal = <T = unknown>() => {
  const resolverRef = useRef<((v: T) => void) | null>(null);
  const [open, setOpen] = useState(false);

  const waitResult = useCallback(() => {
    setOpen(true);

    return new Promise<T>((resolve) => {
      resolverRef.current = (v: T) => {
        resolve(v);
        resolverRef.current = null;
        setOpen(false);
      };
    });
  }, []);

  const resolve = useCallback((v: T) => {
    resolverRef.current?.(v);
  }, []);

  const cancel = useCallback((fallback: T | undefined) => {
    resolverRef.current?.(fallback as T);
  }, []);

  return {
    open, setOpen, waitResult, resolve, cancel,
  };
};
